export interface DocumentWrapperData {
    html: string;
    backgroundColor?: string;
    backgroundImage?: string;
    backgroundImageId?: string;
    width?: string;
    height?: string;
    padding?: string;
}

export class DocumentWrapperService {
    // 1. parse html to object
    static parse(rawHtml: string): DocumentWrapperData {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = rawHtml.trim();

        const root = wrapper.firstElementChild as HTMLElement | null;
        if (!root) {
            return { html: rawHtml };
        }

        const style = root.style;

        return {
            html: root.innerHTML,
            backgroundColor: this.rgbToHex(style.backgroundColor || ""),
            backgroundImage: style.backgroundImage?.replace(/^url\(["']?|["']?\)$/g, "") || undefined,
            backgroundImageId: root.getAttribute("data-background-image-id") || undefined,
            width: style.width || undefined,
            height: style.height || undefined,
            padding: style.padding || undefined,
        };
    }

    // 2. build final html
    static build(data: DocumentWrapperData): string {
        const { html, backgroundColor, backgroundImage, backgroundImageId, width, height, padding } = data;

        let style = "";

        if (backgroundColor) style += `background-color: ${backgroundColor}; `;
        if (backgroundImage) {
            style += `background-image: url(${backgroundImage}); background-size: cover; background-repeat: no-repeat; background-position: center;`;
        }
        if (width) style += `width: ${width}; `;
        if (height) style += `height: ${height}; `;
        if (padding) style += `padding: ${padding}; `;

        const backgroundImageIdAttr = backgroundImageId ? ` data-background-image-id="${backgroundImageId}"` : "";
        return `<div class="document" style="${style.trim()}"${backgroundImageIdAttr}>${html}</div>`;
    }

    static rgbToHex(rgb: string): string | undefined {
        const match = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        if (!match) return undefined;
        const [r, g, b] = match.slice(1).map(Number);
        return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
    }
}
